import { getPersistedCbtToken } from "../data/persistentStorage";

export function getCbtToken(user, frontendSettings, customerUsername) {
  if (customerUsername === null) {
    return null;
  }

  return (
    frontendSettings?.dealerCorporateSettings?.enableCbt === "true" &&
    (user.cbtToken ? user.cbtToken : getPersistedCbtToken())
  );
}
